import { render, staticRenderFns } from "./videoshiyan.vue?vue&type=template&id=4fa4150a"
import script from "./videoshiyan.vue?vue&type=script&lang=js"
export * from "./videoshiyan.vue?vue&type=script&lang=js"
import style0 from "./videoshiyan.vue?vue&type=style&index=0&id=4fa4150a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports